import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <SEO
        title="Siden blev ikke fundet - Power-Multiservice"
        description="Den side, du leder efter, kunne desværre ikke findes. Gå til forsiden eller benyt vores prisberegner."
      />

      <div className="max-w-lg w-full text-center bg-white p-8 sm:p-12 border border-slate-200 shadow-xl space-y-6">
        <div className="w-20 h-20 bg-blue-50 text-blue-900 flex items-center justify-center mx-auto text-3xl font-black">
          404
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">
            Siden blev ikke fundet
          </h1>
          <p className="text-slate-600 text-sm leading-relaxed">
            Vi kunne desværre ikke finde den side, du ledte efter. Den kan være flyttet, eller adressen er tastet forkert.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
          <Link
            to="/"
            className="w-full sm:w-auto px-6 py-3 rounded-full font-bold text-sm text-white bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/prisberegner"
            className="w-full sm:w-auto px-6 py-3 rounded-full font-bold text-sm text-emerald-800 bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 transition-all flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-calculator text-xs text-emerald-600" aria-hidden="true" />
            <span>Prisberegner</span>
          </Link>
        </div>

        <div className="pt-4 border-t border-slate-100 text-xs text-slate-500">
          <span>Har du brug for hjælp? </span>
          <Link to="/kontakt" className="text-blue-900 font-bold hover:underline">
            Kontakt Power-Multiservice
          </Link>
        </div>
      </div>
    </div>
  );
}
